// extracted by mini-css-extract-plugin
module.exports = {"root":"LandingPageFlex_root__3SQ9L","trustPilotLogo":"LandingPageFlex_trustPilotLogo__3RS9i","trustPilotLogoContent":"LandingPageFlex_trustPilotLogoContent__3HCZK"};